// 封装axios
import axios from "axios"
import qs from "qs"

var host
// process.env是Nodejs提供的一个API，它返回一个包含用户环境信息的对象。
// 通过NODE_ENV 判断当前环境是生产环境(production)还是开发环境(development) 自动切换不同域名
// 暂时开发环境和生产环境  所以域名暂时一样
// eslint-disable-next-line no-undef
if (process.env.NODE_ENV == "development") {
  //开发环境
  host = "https://www.bmjzkj.com/bimwebsite/public"
} else {
  host = "https://www.bmjzkj.com/bimwebsite/public"
}

// 实例
var instance = axios.create({
  // 基础地址
  baseURL: host,
  // timeout: 10*1000
})

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // qs处理post参数
    // if (config.method.toLocaleLowerCase() === 'post') {
    //     config.data=qs.stringify(config.data)
    // }
    config.data = qs.stringify(config.data)
    // config.headers.token = Cookies.get('userinfo') ? JSON.parse(Cookies.get('userinfo')).token : ''
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (res) => {
    // if (res.data.code === 1) {
    //     PM.showMsg(res.data.msg, 'success')
    // } else {
    //     PM.showMsg(res.data.msg, 'error')
    // }
    return res.data
  },
  (err) => {
    return Promise.reject(err)
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/utils/request.js